import { render, staticRenderFns } from "./PersonDetailDialog.vue?vue&type=template&id=33dbc862&scoped=true&"
import script from "./PersonDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PersonDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PersonDetailDialog.vue?vue&type=style&index=0&id=33dbc862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dbc862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33dbc862')) {
      api.createRecord('33dbc862', component.options)
    } else {
      api.reload('33dbc862', component.options)
    }
    module.hot.accept("./PersonDetailDialog.vue?vue&type=template&id=33dbc862&scoped=true&", function () {
      api.rerender('33dbc862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/components/PersonDetailDialog.vue"
export default component.exports